import { render } from "./BandcampPlayer.vue?vue&type=template&id=f39ab2d0"
import script from "./BandcampPlayer.vue?vue&type=script&lang=js"
export * from "./BandcampPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__